export default __webpack_public_path__ + "static/media/codeIgniter.44294bf5.png";